(function () {
  var avatarUrl = document.documentElement.getAttribute('data-tcb-tidio-avatar');
  if (!avatarUrl) return;

  var patched = typeof WeakSet === 'function' ? new WeakSet() : null;

  function shouldPatch(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList && el.classList.contains('emoji')) return false;
    var cls = el.className && el.className.toString ? el.className.toString() : '';
    return cls.indexOf('header-ava') !== -1 || cls.indexOf('HeaderAvatar') !== -1;
  }

  function patchNode(el) {
    if (!shouldPatch(el)) return;
    if (patched && patched.has(el)) return;

    el.style.backgroundImage = 'url("' + avatarUrl + '")';
    el.style.backgroundSize = 'cover';
    el.style.backgroundPosition = 'center 18%';
    el.style.backgroundRepeat = 'no-repeat';

    el.querySelectorAll('img').forEach(function (img) {
      if (img.classList.contains('emoji')) return;
      img.src = avatarUrl;
      img.style.objectFit = 'cover';
      img.style.objectPosition = 'center 18%';
    });

    el.querySelectorAll('svg').forEach(function (svg) {
      svg.style.opacity = '0';
    });

    if (patched) patched.add(el);
  }

  function patchTidio(root) {
    if (!root) return;
    root.querySelectorAll('.header-ava, [class*="header-ava"], [class*="HeaderAvatar"]').forEach(patchNode);
  }

  function bindObserver(chat) {
    patchTidio(chat);
    if (!('MutationObserver' in window)) return;
    var timer = null;
    var observer = new MutationObserver(function () {
      if (timer) return;
      timer = window.setTimeout(function () {
        timer = null;
        patchTidio(chat);
      }, 120);
    });
    observer.observe(chat, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'src'] });
  }

  function init() {
    var chat = document.getElementById('tidio-chat');
    if (!chat) return;
    bindObserver(chat);
  }

  if (window.tidioChatApi && window.tidioChatApi.readyEventWasFired) init();
  document.addEventListener('tidioChat-ready', init);
})();
